export enum LogicalOperator {
  AND = 'and',
  OR = 'or'
}
